import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { filterStudyList } from '../../../util/CommonUtils';


class SubscriptionStudySelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchNodes: [],
      expanded: [],
      nodes: [],
      checked: [],
      tempChecked: [],
      data: props.studies !== undefined
        ? filterStudyList(props.studies, props.featureID)
      : [],
    };
  }

  componentDidMount() {
    this.onMountMethod();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.studies !== nextProps.studies) {
      this.setState({
        data: filterStudyList(nextProps.studies, nextProps.featureID),
      }, () => {
        this.categorizeStudyData();
      });
    }
  }

  onMountMethod = () => {
    if (this.state.data !== undefined) {
      this.categorizeStudyData();
    }
  }

  categorizeStudyData = () => {
    const tempData = _.cloneDeep(this.state.data);
    const tempDataWCategory = [];
    function filterData(studies) {
      return _.map(studies, val => (
       { value: val.pn, label: val.sd, source: val.ss }
      ));
    }
    if (tempData !== undefined && tempData.length > 0) {
      _.forEach(tempData, o => {
        tempDataWCategory.push({
          value: o.sgd,
          label: o.sgd,
          children: filterData(o.sl),
        });
      });
    }
    this.setState({
      nodes: tempDataWCategory,
    });
  }

  checkIsExpanded = category => {
    const curExpandedList = _.cloneDeep(this.state.expanded);
    if (curExpandedList.length > 0) {
      return _.find(curExpandedList, cat => (cat === category)) !== undefined;
    }
    return false;
  };

  handleOnExpand = category => {
    const curExpandedList = _.cloneDeep(this.state.expanded);
    if (curExpandedList.length > 0 &&
      _.find(curExpandedList, cat => (cat === category)) !== undefined) {
      _.remove(curExpandedList, el => el === category);
    } else {
      curExpandedList.push(category);
    }
    this.setState({
      expanded: curExpandedList,
    });
  }

  render() {
    return (
      <div className="common-study-selector subscription-study-selector">
        <div className="study-dropdown-list">
          {this.state.searchNodes !== undefined && (
            <div className="study-result-listing">
              <ol>
                {(this.state.searchNodes.length > 0
                  ? this.state.searchNodes
                  : this.state.nodes
                ).map(node => (
                  <li
                    key={node.value}
                    className={`study-result-list ${
                      this.checkIsExpanded(node.value)
                        ? 'expanded'
                        : 'collapsed'
                    }`}
                  >
                    <span
                      title={node.label}
                      onClick={() => this.handleOnExpand(node.value)}
                      className="study-result-list-title"
                    >
                      {node.label}
                    </span>
                    <ol className="study-result-list-child">
                      {node.children.map(childNode => (
                        <li key={childNode.value}>
                          <span
                            title={childNode.label}
                            data-source={childNode.source}
                            className="study-result-list-label"
                          >
                            {childNode.label}
                          </span>
                        </li>
                      ))}
                    </ol>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
      </div>
    );
  }
}

SubscriptionStudySelector.propTypes = {
  studies: PropTypes.instanceOf(Array),
  featureID: PropTypes.number,
};

export default SubscriptionStudySelector;
